/**
 * Created by dok on 01/02/2017.
 */
angular.module('tf.controllers')

    .controller('ManageGroupController', ['$scope', 'FarmService', 'NotificationService', '$timeout', 'group','$q',
        function ($scope, FarmService, NotificationService, $timeout, group, $q) {

            $scope.settingsChanged = false;
            $scope.group = angular.copy(group);

            $scope.users = {
                users : []
            };

            setTimeout(function(){$('.modal input').first().focus();},1);

            FarmService.getMembers().then(function(members){
                $scope.members = members;
            });


            var addMembersToGroup = function(emails){
                var defer = $q.defer();
                if(emails && emails.length){
                    FarmService.addMembersToGroup(emails, $scope.group).then(function () {
                        defer.resolve();
                    });
                } else {
                    defer.resolve();
                }
                return defer.promise;
            };

            $scope.removeMemberFromGroup = function(member){
                NotificationService.confirm("Remove Member from group",  "Are you sure that you want to remove "+(member.local.first_name?member.local.first_name:member.local.email)+" from this group?", function() {
                    FarmService.removeMemberFromGroup(member, $scope.group).then(function () {
                        $scope.group.members = _.without($scope.group.members, _.find($scope.group.members, {id: member.id}));
                        $scope.settingsChanged = true;
                    });
                });
            };

            $scope.saveGroup = function(){
                $scope.isWorking = true;
                var emails = _.chain($scope.users.users).pluck('local').pluck('email').map(function(email){ return email.trim();}).value();
                addMembersToGroup(emails).then(function(){
                    FarmService.updateGroup($scope.group).then(function(){
                        $scope.$close(true);
                    });
                });
            };
            $scope.deleteGroup = function(){
                NotificationService.confirm("Delete Group", "Are you sure that you want to delete "+$scope.group.name+"?", function() {
                    FarmService.deleteGroup($scope.group).then(function(){
                        $scope.$close(true);
                    });
                });
            };


            var unwatchGroup, unwatchUsers;

            unwatchGroup = $scope.$watch('group', function(newVal, oldVal){
                if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                    unwatchUsers();
                    unwatchGroup();
                    $scope.settingsChanged = true;
                }
            }, true);

            unwatchUsers = $scope.$watch('users', function(newVal, oldVal){
                if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                    unwatchUsers();
                    unwatchGroup();
                    $scope.settingsChanged = true;
                }
            }, true);

            $scope.cancel = function(){
                if($scope.settingsChanged) {
                    event.preventDefault();
                    NotificationService.popup('confirm-settings-exit', {
                        onLeave: function(){
                            $timeout(function(){$scope.$close();},200);
                        }
                    },{backdrop : false});
                } else {
                    $scope.$close();
                }
            };
            $scope.getRole = function(user){
                var farm;
                if(user.farms) farm = user.farms.find(function(farm){return farm.farm === $scope.farmId;});
                if(!farm && user.pending_invites){
                    farm = user.pending_invites.find(function(invite) {return invite.farm === $scope.farmId;});
                }
                return farm && farm.role;
            };
        }
    ]
);
